import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import * as actions from "../../../actions";

import { Modal, Tooltip } from "flowbite-react";
import { Popup } from "../../../components/pop-up";
import { RESET2FA_RESPONSE } from "../../../constants/action_types";
import { FlatButton, IconButton } from "../../../components/buttons";

export function Reset2FA({ data, type = "icon" }) {
  const dispatch = useDispatch();

  const coworkerUpdated = useSelector(
    (state) => state.coworker.update_response
  );

  useEffect(() => {
    if (coworkerUpdated?.type === RESET2FA_RESPONSE) {
      setQRcode(coworkerUpdated?.payload?.data);
    }
  }, [coworkerUpdated]);

  const [_2faModal, set2faModal] = useState();
  const [qrCode, setQRcode] = useState();
  const [qrModalState, setQRModalState] = useState();

  useEffect(() => {
    if (qrCode) setQRModalState("pop-up");
  }, [qrCode]);

  const closeModal = () => {
    dispatch(actions.RESET_STATE("coworker.update_response"));
    setQRModalState(undefined);
    setQRcode(undefined);
  };
  return (
    <>
      {type === "icon" && (
        <Tooltip placement="bottom" content="Reset 2FA">
          <IconButton
            size="sm"
            onClick={() => set2faModal("pop-up")}
            class="rounded-xl bg-indigo-100 p-2 text-indigo-600 hover:bg-indigo-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.75 6.75h.75v.75h-.75v-.75zM6.75 16.5h.75v.75h-.75v-.75zM16.5 6.75h.75v.75h-.75v-.75zM13.5 13.5h.75v.75h-.75v-.75zM13.5 19.5h.75v.75h-.75v-.75zM19.5 13.5h.75v.75h-.75v-.75zM19.5 19.5h.75v.75h-.75v-.75zM16.5 16.5h.75v.75h-.75v-.75z"
              />
            </svg>
          </IconButton>
        </Tooltip>
      )}
      {type === "text" && (
        <FlatButton
        size="lg"
          onClick={() => set2faModal("pop-up")}
          // className="font-normal underline underline-offset-8 hover:text-indigo-500"
          appearance="secondary"
        >
          Reset 2FA key
        </FlatButton>
      )}
      <Popup
        modalState={[_2faModal, set2faModal]}
        onConfirm={() => {
          dispatch(actions.RESET2FA_REQ(data));
          set2faModal();
        }}
        content={
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Resetting 2FA Key will lead to Session expiry on logged in
              devices. Make sure to save the new Key and scan the QR code.
            </h3>
          </>
        }
      />{" "}
      <Modal
        show={qrModalState === "pop-up"}
        size="2xl"
        popup
        onClose={() => closeModal()}
      >
        <Modal.Header />
        <Modal.Body>
          <div className="flex flex-row flex-nowrap items-center">
            {qrCode && (
              <>
                <img className="h-13 w-13" src={qrCode.qr} alt="" />
                <h3 className="mb-5 ml-4 text-md font-normal text-gray-500 dark:text-gray-500">
                  Coworker's 2FA key has been updated successfully.
                  <br />
                  <br /> Please Scan the QR Code with Google Authenticator and
                  Save this Secret key to recover account incase if lost.
                  <br />
                  <p
                    className="inline-block cursor-pointer text-blue-500 text-underline"
                    onClick={() => {
                      window.open(qrCode.qr);
                    }}
                  >
                    Click here
                  </p>{" "}
                  to open QR Code in new tab <br />
                  <br />
                  <b className="font-bold text-md ">
                    SECRET KEY:
                    <br /> {qrCode.secret_key}
                  </b>
                </h3>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
